export default function initRangeSliders() {
  $('input[type="range"]').each((index, elem) => {
    const $elem = $(elem);
    const $output = $elem.parents('.range-slider').siblings('.range-output');
    $elem.rangeslider({
      polyfill: false,
      onInit: () => $output.html($elem.val()),
      onSlide: (position, value) => $output.html(value),
    });
  });
}

$(document).on('ready turbolinks:load', () => {
  initRangeSliders();
});
